export const getGroups = (group, type) => {
  if (
    process.env.REACT_APP_REDEMPTION_HIERARCHY_GROUPS ||
    process.env.REACT_APP_REDEMPTION_SPOT_GROUPS
  ) {
    let groups = null;
    if (type === 3) {
      groups = process.env.REACT_APP_REDEMPTION_HIERARCHY_GROUPS.split(",");
    } else {
      groups = process.env.REACT_APP_REDEMPTION_SPOT_GROUPS.split(",");
    }

    if (groups.find((x) => x === group)) {
      return true;
    }
    return false;
  }
  return false;
};
